<ng-container [formGroup]="addSubcontractorForm">
  <div class="card-body">

    <div class="d-flex">
      <h2>Add Subcontractor </h2>
    </div>

    <div class="form-row">
      <div class="form-group col-12">
        <label for="name" class="custom_label">Name *</label>
        <input matInput type="text" id="name" formControlName="name" class="form-control" placeholder="Name" name="name">
        <app-validation-error [formGroup]="addSubcontractorForm" [controlName]="'name'"></app-validation-error>
      </div>
    </div>

    <div class="form-row">
      <div class="form-group col-12">
        <label for="name" class="custom_label">Email </label>
        <input matInput type="email" id="email" formControlName="email" class="form-control" placeholder="Email" name="email" (keydown)="preventspace($event)">
        <app-validation-error [formGroup]="addSubcontractorForm" [controlName]="'email'"></app-validation-error>
      </div>
    </div>

    <div class="form-row">
      <div class="form-group col-12">
        <label for="name" class="custom_label">Phone Number </label>
        <input matInput phoneMask type="text" id="phone" formControlName="phone" class="form-control" placeholder="Phone Number" name="phone">
        <app-validation-error [formGroup]="addSubcontractorForm" [controlName]="'phone'"></app-validation-error>
      </div>
    </div>

    <div class="form-row">
      <div class="form-group col-12">
        <label for="name" class="custom_label">Alternate Phone Number </label>
        <input matInput phoneMask type="text" id="alternate_phone" formControlName="alternate_phone" class="form-control" placeholder="Alternate Phone" name="alternate_phone">
        <app-validation-error [formGroup]="addSubcontractorForm" [messagePhoneNumber]="'Invalid Alternate Phone Number'" [controlName]="'alternate_phone'"></app-validation-error>
      </div>
    </div>

  </div>
</ng-container>
